import dayjs from 'dayjs';
import type { ConversationMessageTypeUnion } from '@/models/conversations/conversation';

type GroupedItem = { isDate: true; key: string; timestamp: number } | ConversationMessageTypeUnion;

export function groupMessagesByMinutes(messages: ConversationMessageTypeUnion[]): GroupedItem[] {
  const result: GroupedItem[] = [];
  if (!Array.isArray(messages) || messages.length === 0) return result;

  let lastHeaderKey: string | null = null;

  for (const item of messages) {
    // Header grouping key by calendar day
    const messageTime = dayjs(item.CreateTime);
    const headerKey = messageTime.format('YYYY-MM-DD HH:mm');

    // Show header when day changes or when no header yet
    const shouldShowHeader = headerKey !== lastHeaderKey;

    if (shouldShowHeader) {
      result.push({
        isDate: true,
        key: headerKey,
        timestamp: messageTime.startOf('minute').valueOf(),
      });
      lastHeaderKey = headerKey;
    }

    result.push(item);
  }

  return result;
}
